import { setCategoryDeepDiveData } from "../store/components/Reports.slice";
import store from "../store/store";
import getState from "../utils/MainHelper";
import { getCountryCode, getModuleCode, getPackage } from "../utils/oneintelligence/OneIntelligenceHelper";
import MainServices from "./Main.services";


class TopLevelCacheServices {
    constructor() {
        this.cachePath = "oneintel/cache/"
    }
    getTargetName() {
        const { targets } = getState("minified");
        const newList = targets.map((target) => target.toLocaleLowerCase()).sort()
        return newList.join(",")
    }

    getCacheCountryPath() {
        return `${this.cachePath}${getPackage()}/${getModuleCode()}/${getCountryCode("enterprise")}/`
    }

    getMinifiedResultCachePath(isNegative) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/minifiedResultDeepdive${(isNegative ? "Negative" : "")}.json`
    }

    getMinifiedRecTextCachePath(type) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/recommendedText${type}.json`
    }

    getMinifiedAgeGenderCachePath(type) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/ageGenderDistribution${type}.json`
    }

    getMinifiedPersonasCachePath(type) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/personasData${type}.json`
    }

    getMinifiedPersonasImageCachePath(type) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/personasImage${type}.json`
    }

    getMinifiedInsightsCachePath(item) {
        return `${this.getCacheCountryPath()}${this.getTargetName()}/insightsItem${item}.json`
    }

    getMinifiedResultCache(isNegative) {
        if (window.useS3Cache === false) return Promise.resolve()
        const { dispatch } = store;
        return MainServices.getFile(this.getMinifiedResultCachePath(isNegative)).then(async (resp) => {
            if (resp && !isNegative) {
                await dispatch(setCategoryDeepDiveData(resp))
            }
            return resp
        })
    }
    setMinifiedResultCache(data, isNegative) {
        return MainServices.uploadFile(this.getMinifiedResultCachePath(isNegative), JSON.stringify(data), {});
    }

    getMinifiedRecTextCache(type) {
        return MainServices.getFile(this.getMinifiedRecTextCachePath(type));
    }

    setMinifiedRecTextCache(data, type) {
        return MainServices.uploadFile(this.getMinifiedRecTextCachePath(type), JSON.stringify(data), {});
    }

    getMinifiedAgeGenderCache(type) {
        return MainServices.getFile(this.getMinifiedAgeGenderCachePath(type));
    }

    setMinifiedAgeGenderCache(data, type) {
        return MainServices.uploadFile(this.getMinifiedAgeGenderCachePath(type), JSON.stringify(data), {});
    }

    getMinifiedPersonasCache(type) {
        return MainServices.getFile(this.getMinifiedPersonasCachePath(type));
    }

    setMinifiedPersonasCache(data, type) {
        return MainServices.uploadFile(this.getMinifiedPersonasCachePath(type), JSON.stringify(data), {});
    }

    getMinifiedPersonasImageCache(type) {
        return MainServices.getFile(this.getMinifiedPersonasImageCachePath(type));
    }

    setMinifiedPersonasImageCache(data, type) {
        return MainServices.uploadFile(this.getMinifiedPersonasImageCachePath(type), JSON.stringify(data), {});
    }

    getMinifiedInsightsCache(item) {
        return MainServices.getFile(this.getMinifiedInsightsCachePath(item));
    }

    setMinifiedInsightsCache(data, item) {
        return MainServices.uploadFile(this.getMinifiedInsightsCachePath(item), JSON.stringify(data), {});
    }
}

export default new TopLevelCacheServices();
